export { withSerializer } from "./plugin.js";
export type { SerializableRequest, SerializerOptions } from "./plugin.js";
